/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 *
 * Whether a refetched payload says exactly what the page already shows. A
 * baked page is seeded with its data and fetches it again after hydration in
 * case the bake is stale; a fresh parse is a new object even when nothing
 * changed, and handing that to setState re-renders everything below it. Same
 * JSON = keep the object on screen, and React skips the render (the rule in
 * CLAUDE.md, "Nothing re-renders the page right after hydration"). On the
 * homepage's provider feed, measured 2026-10-02: about 900 components and
 * 0.5–0.7 s of main thread per refetch on a phone profile at 4x CPU slowdown.
 * The page structure goes through src/hooks/usePageStructure.ts.
 */
export const sameJson = (a: unknown, b: unknown): boolean => {
  if (a === b) return true;
  try {
    return JSON.stringify(a) === JSON.stringify(b);
  } catch {
    return false;
  }
};
